module.exports = __webpack_public_path__ + "static/media/02n.0c6ad461.png";